import React, { useRef } from "react";
import { useFieldArray } from "react-hook-form";
import useTranslations from "../../hooks/useTranslations";
import { DeleteIcon, PlusIcon } from "../icons";
import { Button, Input } from "../wombat-ui";

interface InnerQuestionOptionsConfiguratorProps {
  name: string;
  parentFieldIndex;
  register;
  control;
}

type QuestionOption = {
  label: string;
  value: string;
};


const InnerQuestionOptionsConfigurator: React.FC<InnerQuestionOptionsConfiguratorProps> = ({
  name,
  parentFieldIndex,
  register,
  control,
}) => {
  const t = useTranslations();
  const fullName = `questionOptionsConfigurationsAttributes[${parentFieldIndex}].${name}`;
  const {
    append: append,
    remove: remove,
    fields,
  } = useFieldArray<QuestionOption>({
    control,
    name: fullName,
  });

  const inputRef = useRef<HTMLInputElement>();

  return (
    <>
      {fields.map((field, fieldIndex) => {
        return (
          <React.Fragment key={field.id}>
            <div className={`flex items-center space-y-2`} key={field.id}>
              <span className="w-20 text-xs text-primary-800">
                Option {fieldIndex + 1}
              </span>
              <div className="flex-grow space-y-2">
                <Input
                  srOnlyLabel
                  label={`Option ${fieldIndex}`}
                  name={`${fullName}[${fieldIndex}].label`}
                  defaultValue={field.label}
                  ref={register()}
                  id={`${fullName}[${fieldIndex}].label`}
                />
                <input
                  type="hidden"
                  ref={register()}
                  defaultValue={`${fieldIndex}`}
                  name={`${fullName}[${fieldIndex}].value`}
                />
              </div>
              <Button
                icon={DeleteIcon}
                variant="ghost"
                onClick={() => {
                  remove(fieldIndex);
                }}
                id={`${fullName}[${fieldIndex}].deleteButton`}
              />
            </div>
          </React.Fragment>
        );
      })}
      <div className="flex items-center flex-grow pt-4 space-x-4">
        <div className="flex-grow">
          <Input
            srOnlyLabel
            label={t("reviews.addOption") as string}
            placeholder={t("reviews.addOption") as string}
            id={`${fullName}.addOptionLabel`}
            ref={inputRef}
          />
        </div>
        <Button
          icon={PlusIcon}
          id={`${fullName}.addOptionButton`}
          onClick={() => {
            if (inputRef?.current?.value) {
              append({
                value: fields.length.toString(),
                label: inputRef.current.value,
              });
              inputRef.current.value = "";
            }
          }}
        />
      </div>
    </>
  );
};

export default InnerQuestionOptionsConfigurator;
